<ion-content>
  <div class="sticky-top or-bg-white or-pt-16-px">
    <div class="or-px-24-px or-d-flex or-align-items-center or-justify-content-between or-mb-16-px">
      <div class="or-head-lg">Wybierz lokalizację</div>
      <ion-icon name="close" class="or-head-lg or-color-black or-cursor-pointer" (click)="close()"></ion-icon>
    </div>

    @if (selected) {
      <div class="location-divider"></div>
      <div class="or-bg-shade or-px-24-px or-py-12-px">
        <div class="or-text-md or-color-secondary-2">Aktualnie wybrane:</div>
        <div class="or-head-sm or-color-black or-mt-4-px">{{ selected.name }} ({{ selectedSourceLabel() }})</div>
      </div>
      <div class="location-divider or-mb-16-px"></div>
    } @else {
      <div class="location-divider or-mb-16-px"></div>
    }

    <div class="or-px-24-px">
      <button
        (click)="locateAutomatically()"
        class="button-primary-style or-h-48-px or-text-md or-w-100-pc or-d-flex or-align-items-center or-justify-content-center or-mb-16-px">
        <or-icon name="location" size="s" class="or-color-white or-mr-8-px" />

        Zlokalizuj mnie automatycznie
      </button>
    </div>
  </div>

  <div class="location-divider or-mb-16-px"></div>

  <div class="or-px-24-px">
    <or-input-with-icon [formControl]="searchControl" [icon]="'assets/icons/search-icon.svg'" placeholder="Wyszukaj...">
    </or-input-with-icon>
  </div>

  <div class="or-px-24-px or-pb-24-px">
    @if (query()) {
      <div class="or-head-xs or-color-secondary-2 or-mt-16-px or-mb-8-px">WYNIKI WYSZUKIWANIA</div>
      @for (city of results(); track city.placeId) {
        <div (click)="selectSuggestion(city)" class="or-text-lg or-p-16-px or-cursor-pointer">{{ city.name }}</div>
      } @empty {
        @if (!isSearching()) {
          <div class="or-text-md or-color-secondary-2 or-p-16-px or-text-align-center">Brak wyników</div>
        }
      }
    } @else {
      <div class="or-head-xs or-color-secondary-2 or-mt-16-px or-mb-8-px">NAJPOPULARNIEJSZE MIASTA</div>
      @for (city of popularCities; track city.name) {
        <div (click)="selectKnownCity(city)" class="or-text-lg or-p-16-px or-cursor-pointer">{{ city.name }}</div>
      }
    }
  </div>
</ion-content>
